import { render } from "./EditFingerspotAttendance.vue?vue&type=template&id=b726d1c8"
import script from "./EditFingerspotAttendance.vue?vue&type=script&lang=js"
export * from "./EditFingerspotAttendance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__